import { render, staticRenderFns } from "./FqaDictDataEdit.vue?vue&type=template&id=72650e0c&"
import script from "./FqaDictDataEdit.vue?vue&type=script&lang=js&"
export * from "./FqaDictDataEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports